import { render, staticRenderFns } from "./ISFDetailHeader.vue?vue&type=template&id=84c447f6&"
import script from "./ISFDetailHeader.vue?vue&type=script&lang=js&"
export * from "./ISFDetailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports